import { getErrors } from 'api/client';
import {
  setSuccess,
  setError,
  setIsLoading,
  initialState
} from './move-in-date-slice';
import { verifyMoveIn } from 'api/home-move-verify';

export const moveInDateVerifyThunk = ({ udprn, moveInDate }) => async (
  dispatch
) => {
  try {
    dispatch(setIsLoading());
    const response = await verifyMoveIn({ udprn, moveInDate });
    const errors = response.errors;
    const hasErrors = !!errors?.length;

    if (hasErrors) {
      dispatch(setError(errors));
      return Promise.reject(response);
    }

    dispatch(setError(initialState.errors));
    dispatch(setSuccess(response));
    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
